<template>
  <PaperCard :has_header="false">
    <template #body>
      <div>
        <p class="text-strongest text-lg font-semibold font-inter mb-[.375rem]">
          Select the entity
        </p>
        <p class="text-strong text-sm font-medium font-inter">
          Entity account you are buying the bonds with
        </p>
      </div>
      <div>
        <div class="grid grid-cols-2 gap-4 mt-8 mb-4">
          <div
            v-if="dataStore.entity_accounts?.length > 0"
            v-for="entity_account in dataStore.entity_accounts"
            @click="purchaseFlowStore.active_entity_account = entity_account"
            class="cursor-pointer col-span-2 lg:col-span-1 rounded-xl p-4 flex items-center justify-between gap-3 h-[64px] lg:h-[85px]"
            :class="
              isEntityAccountSelected(entity_account.record_id) ? 'bg-radio-checkbox-selector' : ''
            "
          >
            <div class="flex items-center gap-5">
              <div
                class="h-6 w-6 rounded-full flex items-center justify-center border border-radio-checkbox-outline"
                :class="
                  isEntityAccountSelected(entity_account.record_id)
                    ? 'bg-radio-checkbox-checked border-transparent'
                    : 'bg-transparent border border-radio-checkbox-outline'
                "
              >
                <Icon
                  v-if="isEntityAccountSelected(entity_account.record_id)"
                  name="Check"
                  class="text-container-bg h-4.5 w-4.5"
                  :stroke-width="2.5"
                />
              </div>
              <div>
                <p
                  class="font-inter whitespace-nowrap text-sm lg:text-lg text-strongest"
                  :class="
                    isEntityAccountSelected(entity_account.record_id)
                      ? 'font-semibold'
                      : 'font-medium'
                  "
                >
                  {{ entity_account.name }}
                </p>
                <p
                  class="text-sm lg:text-base font-semibold font-inter"
                  :class="
                    isEntityAccountSelected(entity_account.record_id)
                      ? 'text-stronger'
                      : 'text-strong'
                  "
                >
                  {{ signedInvestmentsForEntityAccount(entity_account.record_id).length }}
                  investment{{
                    signedInvestmentsForEntityAccount(entity_account.record_id).length === 1
                      ? ""
                      : "s"
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <Button @click="handleNewEntityAccountSelection" variant="paper-primary">
          <template #label>Add new entity account</template>
          <template #icon>
            <Icon name="Plus" class="h-4 w-4" :stroke-width="3" />
          </template>
        </Button>
      </div>
    </template>
  </PaperCard>
</template>

<script setup>
import { useDataStore, usePurchaseFlowStore } from "@/stores";
import { PaperCard, Icon, Button } from "@/components";
import { ENTITY_TEMPLATE } from "@/constants";

const purchaseFlowStore = usePurchaseFlowStore();
const dataStore = useDataStore();

function isEntityAccountSelected(entity_account_record_id) {
  return purchaseFlowStore.active_entity_account.record_id === entity_account_record_id;
}

function signedInvestmentsForEntityAccount(entity_account_record_id) {
  return dataStore.investments.filter(
    (investment) =>
      investment.entity_account_id === entity_account_record_id && investment.signature_date
  );
}

function handleNewEntityAccountSelection() {
  purchaseFlowStore.active_entity_account = ENTITY_TEMPLATE;
  purchaseFlowStore.current_substep = 2;
}
</script>
